module.exports = __webpack_public_path__ + "static/media/refresh.899514fa.svg";